export default __webpack_public_path__ + "static/media/h-lr-a.1bf25cff.png";